import { createFeatureSelector } from '@ngrx/store';
import type { RichTextField } from '@sitecore-jss/sitecore-jss-angular';
import type { Answer } from '@front-end/ngx-interview';

import type { QuestionnaireOfferValues } from './questions.model';

export enum QuestionnaireStep {
  Start = 'start',
  Questions = 'questions',
  Finish = 'finish',
}

export interface QuestionnaireResults
  extends Record<QuestionnaireOfferValues, number> {
  highestMatch: QuestionnaireOfferValues;
  answers?: Answer[];
}

export interface State {
  activeStep: QuestionnaireStep;
  questionnaireResults?: QuestionnaireResults;
}

export interface QuestionnaireState {
  readonly [QUESTIONNAIRE_FEATURE_KEY]: State;
}

export const QUESTIONNAIRE_FEATURE_KEY = 'questionnaire';

export const questionnaireFeatureState =
  createFeatureSelector<QuestionnaireState>(QUESTIONNAIRE_FEATURE_KEY);

export interface ScRetentionQuestionnaireContent
  extends ScStartPage,
    ScCloseModal,
    ScFinishPage,
    ScGeneric {
  [key: string]: any;
}

export interface RetentionQuestionnaireModel {
  startPage: {
    title?: string;
    sectionTitle?: string;
    description?: RichTextField;
    usps?: RichTextField;
    startButtonText?: string;
  };
  closeModal: {
    title?: string;
    description?: RichTextField;
    continueButtonText?: string;
    stopButtonText?: string;
  };
  finishPage: {
    title?: string;
    description?: RichTextField;
    finishButtonText?: string;
  };
  generic: {
    nextButtonText?: string;
    previousButtonText?: string;
  };
}

interface ScStartPage {
  StartPageTitle?: string;
  StartPageSectionTitle?: string;
  StartPageDescription?: RichTextField;
  StartPageUSPs?: RichTextField;
  StartPageStartButtonText?: string;
}

interface ScCloseModal {
  CloseModalTitle?: string;
  CloseModalDescription?: RichTextField;
  CloseModalContinueButtonText?: string;
  CloseModalStopButtonText?: string;
}

interface ScFinishPage {
  FinishPageTitle?: string;
  FinishPageDescription?: RichTextField;
  FinishPageFinishButtonText?: string;
}

interface ScGeneric {
  GenericNextButtonText?: string;
  GenericPreviousButtonText?: string;
}
